import { makeStyles } from "@material-ui/core";

import { color, fontFamily } from "../../../../app/theme";

export const useStyles = makeStyles((theme) => ({
  root: { fontFamily: fontFamily.Axiforma },
  headerMonth: {
    color: color.purple[500],
    fontSize: "14px",
    fontWeight: 500,
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: "19.6px"
    }
  },
  headerYear: {
    color: color.purple[500],
    fontSize: "14px",
    fontWeight: 400,
    margin: 0,
    marginLeft: "3px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      marginLeft: "16px"
    }
  },
  headerWeek: {
    color: color.purple[500],
    fontSize: "12px",
    marginBottom: "10px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16.8px",
      marginBottom: "28px"
    }
  },
  dayBox: {
    "border": "solid 0.7px #ececec",
    "borderRadius": "6px",
    "minHeight": "61px",
    "padding": "9px 9px 3px 9px",
    "background": "#e8f0f4",
    "color": color.purple[500],
    "fontSize": "14px",
    "cursor": "pointer",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "pointerEvents": "none",
    "& span": {
      color: "#a7b4bb",
      fontSize: "11px",
      marginTop: "2px",
      [theme.breakpoints.up("sm")]: {
        fontSize: "18px",
        marginTop: "10px",
        width: "80%"
      }
    },
    [theme.breakpoints.up("sm")]: {
      padding: "12px 12px 6px 12px",
      fontSize: "16px",
      minHeight: "80px"
    }
  },
  dayBoxAvailable: {
    "border": "solid 0.7px #bfbfbf",
    "color": color.purple[500],
    "background": "#fff",
    "opacity": 1,
    "pointerEvents": "auto",
    "& span": {
      color: color.orange,
      fontSize: "9px",
      marginTop: "2px",
      overflow: "hidden",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      lineClamp: "2",
      WebkitBoxOrient: "vertical",
      [theme.breakpoints.up("sm")]: {
        color: color.orange,
        marginTop: "10px",
        fontSize: "12px",
        width: "80%"
      }
    }
  },
  dayDisableBox: {
    background: "#f8f8f8",
    border: "solid 0.7px #ececec",
    color: "#b9b9c3",
    pointerEvents: "none"
  },
  dayBoxActive: {
    "background": color.purple[500],
    "color": "#fff",
    "& span": { color: "#fff" }
  }
}));
